import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Tooltip } from "@material-ui/core";
import Breadcrumbs from "components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import filterFactory from "react-bootstrap-table2-filter";

import {
  addLabPathologist,
  getLabPathologists,
  deleteLabPathologist,
} from "../../store/labPathologist/actions";

class LabPathologistAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      mobile_number: "",
      speciality: "",
      errors: {},
      modal: false,
      search: "",

      nameFilter: "",
      emailFilter: "",
      mobileFilter: "",
      specialityFilter: "",

      feedbackListColumns: [
        {
          dataField: "name",
          text: "Name",
          headerStyle: { backgroundColor: "#87ceeb", textAlign: "center" },
          style: { textAlign: "left" }, // ← this aligns the data cells
          headerFormatter: column => (
            <>
              <input
                type="text"
                value={this.state.nameFilter}
                onChange={e => this.setState({ nameFilter: e.target.value })}
                className="form-control"
              />
              <div>{column.text}</div>
            </>
          ),
        },
        {
          dataField: "email",
          text: "Email",
          headerStyle: { backgroundColor: "#87ceeb", textAlign: "center" },
          style: { textAlign: "left" },
          headerFormatter: column => (
            <>
              <input
                type="text"
                value={this.state.emailFilter}
                onChange={e => this.setState({ emailFilter: e.target.value })}
                className="form-control"
              />
              <div>{column.text}</div>
            </>
          ),
        },
        {
          dataField: "mobile_number",
          style: { textAlign: "left" },
          text: "Mobile",
          headerStyle: { backgroundColor: "#87ceeb", textAlign: "center" },
          style: { textAlign: "left" },
          headerFormatter: column => (
            <>
              <input
                type="text"
                value={this.state.mobileFilter}
                onChange={e => this.setState({ mobileFilter: e.target.value })}
                className="form-control"
              />
              <div>{column.text}</div>
            </>
          ),
        },
        {
          dataField: "speciality",
          text: "Speciality",
          headerStyle: { backgroundColor: "#87ceeb", textAlign: "center" },
          headerFormatter: column => (
            <>
              <input
                type="text"
                value={this.state.specialityFilter}
                onChange={e =>
                  this.setState({ specialityFilter: e.target.value })
                }
                className="form-control"
              />
              <div>{column.text}</div>
            </>
          ),
        },
        {
          dataField: "is_notifying_person",
          text: "Type",
          headerStyle: { backgroundColor: "#87ceeb", textAlign: "center" },
          formatter: (cell, row) =>
            row.is_notifying_person ? (
              <span>Previous Pathologist</span>
            ) : (
              <span>Currently Serving</span>
            ),
        },
        {
          dataField: "menu",
          isDummyField: true,
          editable: false,
          text: "Action",
          headerStyle: { backgroundColor: "#87ceeb", textAlign: "center" },
          formatter: (cellContent, pathologist) => (
            <div className="d-flex gap-3 align-items-center">
              {/* <Tooltip title="Update">
                <Link className="text-success" to="#">
                  <i
                    className="mdi mdi-pencil font-size-18"
                    style={{ cursor: "pointer" }}
                    onClick={() => this.toggleEditModal(pathologist)}
                  ></i>
                </Link>
              </Tooltip> */}

              {!pathologist.is_notifying_person && (
                <Tooltip title="Delete">
                  <Link className="text-danger" to="#">
                    <i
                      className="mdi mdi-delete font-size-18"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (window.confirm("Are you sure?")) {
                          this.props.deleteLabPathologist(pathologist.id);
                        }
                      }}
                    ></i>
                  </Link>
                </Tooltip>
              )}
            </div>
          ),
        },
      ],
    };
  }

  validateEmail = email => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  formatPhoneNumber = value => {
    const numbers = value.replace(/\D/g, "").slice(0, 11);

    if (numbers.length <= 4) return numbers;

    return numbers.slice(0, 4) + "-" + numbers.slice(4, 11);
  };

  validatePhoneNumber = number => {
    const regex = /^03\d{2}-\d{7}$/;
    return regex.test(number);
  };

  handleChange = e => {
    const { name, value } = e.target;
    let errors = { ...this.state.errors };

    if (name === "name") {
      this.setState({ name: this.capitalizeWords(value) });
      return;
    }

    if (name === "mobile_number") {
      const formatted = this.formatPhoneNumber(value);
      this.setState({ mobile_number: formatted });

      if (formatted && !this.validatePhoneNumber(formatted)) {
        errors.mobile_number = "Enter valid mobile number (e.g., 0332-1234567)";
      } else {
        delete errors.mobile_number;
      }

      this.setState({ errors });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleSubmit = e => {
    e.preventDefault();

    const { name, email, mobile_number, speciality } = this.state;
    let errors = {};

    if (!this.validateEmail(email)) {
      errors.email = "Enter valid email address";
    }

    if (!this.validatePhoneNumber(mobile_number)) {
      errors.mobile_number = "Enter valid mobile number (e.g., 0332-1234567)";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const data = { name, email, mobile_number, speciality };
    const labId = this.props.match.params.id;

    this.props.addLabPathologist(labId, data);
  };

  toggleModal = () => {
    this.setState(prev => ({ modal: !prev.modal }));
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.success && this.props.success) {
      alert("Lab Pathologist Added Successfully");
      this.setState({
        name: "",
        email: "",
        mobile_number: "",
        speciality: "",
        errors: {},
      });
      this.props.getLabPathologists();

      this.toggleModal();
    }
    if (!prevProps.deleteSuccess && this.props.deleteSuccess) {
      alert("Lab Pathologist Deleted Successfully");
    }
  }

  componentDidMount() {
    this.props.getLabPathologists();
  }
  capitalizeWords = value => {
    return value.replace(/(^|\s)\S/g, char => char.toUpperCase());
  };
  render() {
    const pathologists = this.props.pathologists || [];

    const filteredData = pathologists.filter(item => {
      return (
        (item.name || "")
          .toLowerCase()
          .includes(this.state.nameFilter.toLowerCase()) &&
        (item.email || "")
          .toLowerCase()
          .includes(this.state.emailFilter.toLowerCase()) &&
        (item.mobile_number || "").includes(this.state.mobileFilter) &&
        (item.speciality || "")
          .toLowerCase()
          .includes(this.state.specialityFilter.toLowerCase())
      );
    });

    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Labs" breadcrumbItem="Lab Pathologist Detail" />
          <Row className="justify-content-center align-item-center">
            <p>
              <strong>Note:</strong> Please enter all Pathologists details
              working in the lab
            </p>
            <Card className="shadow-lg">
              <CardBody>
                <Row className="mb-3">
                  <Col className="text-end">
                    <Button
                      style={{
                        backgroundColor: "#1D1DE4",
                        borderColor: "#1D1DE4",
                      }}
                      onClick={this.toggleModal}
                    >
                      Add Pathologist
                    </Button>
                  </Col>
                </Row>

                <PaginationProvider
                  pagination={paginationFactory({
                    sizePerPage: 10,
                    totalSize: filteredData.length,
                    custom: true,
                  })}
                  keyField="id"
                  columns={this.state.feedbackListColumns}
                  data={filteredData}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={filteredData}
                    >
                      {toolkitprops => (
                        <>
                          <div className="table-responsive">
                            <BootstrapTable
                              {...toolkitprops.baseProps}
                              {...paginationTableProps}
                              bordered={false}
                              striped
                              headerWrapperClasses="table-header-sky-blue"
                              classes="table align-middle table-hover"
                              filter={filterFactory()}
                            />
                          </div>

                          <div className="pagination pagination-rounded justify-content-end mt-3">
                            <PaginationListStandalone {...paginationProps} />
                          </div>
                        </>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>
              </CardBody>
            </Card>
            <Modal isOpen={this.state.modal} toggle={this.toggleModal} centered>
              <ModalHeader toggle={this.toggleModal}>
                Add Pathologist
              </ModalHeader>

              <ModalBody>
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Label>Name</Label>
                    <Input
                      type="text"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleChange}
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label>Email</Label>
                    <Input
                      type="email"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      invalid={!!this.state.errors.email}
                      required
                    />
                    <FormFeedback>{this.state.errors.email}</FormFeedback>
                  </FormGroup>

                  <FormGroup>
                    <Label>Mobile Number</Label>
                    <Input
                      type="text"
                      name="mobile_number"
                      placeholder="03**-*******"
                      value={this.state.mobile_number}
                      onChange={this.handleChange}
                      invalid={!!this.state.errors.mobile_number}
                      required
                    />
                    <FormFeedback>
                      {this.state.errors.mobile_number}
                    </FormFeedback>
                  </FormGroup>

                  <FormGroup>
                    <Label>Speciality</Label>
                    <Input
                      type="select"
                      name="speciality"
                      value={this.state.speciality}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select Speciality</option>
                      <option value="Chemical">Chemical</option>
                      <option value="Hematologist">Hematologist</option>
                      <option value="Histopathologist">Histopathologist</option>
                      <option value="Microbiologist">Microbiologist</option>
                      <option value="Molecular Pathologist">
                        Molecular Pathologist
                      </option>
                    </Input>
                  </FormGroup>

                  <div className="text-end mt-3">
                    <Button
                      type="submit"
                      style={{
                        backgroundColor: "#1D1DE4",
                        borderColor: "#1D1DE4",
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              </ModalBody>
            </Modal>
          </Row>
        </Container>
      </div>
    );
  }
}

LabPathologistAdd.propTypes = {
  addLabPathologist: PropTypes.func.isRequired,
  getLabPathologists: PropTypes.func.isRequired,
  deleteLabPathologist: PropTypes.func.isRequired,
  success: PropTypes.bool,
  deleteSuccess: PropTypes.bool,
  pathologists: PropTypes.array,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

const mapStateToProps = state => ({
  success: state.LabPathologist.success,
  deleteSuccess: state.LabPathologist.deleteSuccess,
  pathologists: state.LabPathologist.pathologists,
});

export default withRouter(
  connect(mapStateToProps, {
    addLabPathologist,
    getLabPathologists,
    deleteLabPathologist,
  })(LabPathologistAdd)
);
